import React, { MouseEvent, useCallback, useState } from "react";

import { Activity } from "@mapmycustomers/shared/types/entity";

import AnnotationEditModal from "@app/component/activity/ActivityAnnotation/AnnotationEditModal";
import UpcomingActivitiesCardData from "@app/scene/dashboard/store/cards/upcomingActivities/UpcomingActivitiesCardData";

import ActivityItem from "./ActivityItem";
import styles from "./ListContent.module.scss";

const LOAD_MORE_THRESHOLD = 100; // px

interface Props {
  data?: UpcomingActivitiesCardData;
  onLoadMore?: () => void;
  total?: number;
}

const ListContent: React.FC<Props> = ({ data, onLoadMore, total }) => {
  const handleScroll = useCallback(
    ({ target }) => {
      const { clientHeight, scrollHeight, scrollTop } = target;
      if (
        scrollHeight - clientHeight - scrollTop < LOAD_MORE_THRESHOLD &&
        (data?.activities?.length ?? 0) < (total ?? 0)
      ) {
        onLoadMore?.();
      }
    },
    [data?.activities?.length, total, onLoadMore]
  );

  const [selectedActivityId, setSelectedActivityId] = useState<Activity["id"]>();
  const [annotationElement, setAnnotationElement] = useState<HTMLElement | undefined>();
  const handleHideAnnotation = useCallback(() => setSelectedActivityId(undefined), []);
  const handleClick = useCallback((activityId: Activity["id"], e: MouseEvent) => {
    setSelectedActivityId(activityId);
    setAnnotationElement(e.currentTarget as HTMLElement);
  }, []);

  return (
    <div className={styles.container} onScroll={handleScroll}>
      {(data?.activities || []).map((activity) => (
        <ActivityItem activity={activity} key={activity.id} onClick={handleClick} />
      ))}
      {selectedActivityId && (
        <AnnotationEditModal
          activityId={selectedActivityId}
          element={annotationElement}
          onHide={handleHideAnnotation}
        />
      )}
    </div>
  );
};

export default ListContent;
